<template>
  <Section
    @back="$emit('back')"
    title="対象マンション設定"
    margin
    tip-message="対象マンション設定に戻る"
  >
    <template>
      <v-subheader>価格</v-subheader>
      <v-layout pl-4>
        <v-flex v-if="menuSetting.isValidPriceTarget" xs9>
          {{ priceTargetStr }}
        </v-flex>
        <v-flex v-else xs9>
          指定しない
        </v-flex>
      </v-layout>
    </template>
    <template>
      <v-subheader>階数</v-subheader>
      <v-layout pl-4>
        <v-flex v-if="menuSetting.isValidFloorTarget" xs9>
          {{ floorTargetStr }}
        </v-flex>
        <v-flex v-else xs9>
          指定しない
        </v-flex>
      </v-layout>
    </template>
    <template>
      <v-subheader>築年数</v-subheader>
      <v-layout pl-4>
        <v-flex v-if="menuSetting.isValidAgeBuilt" xs9>
          {{ ageBuiltStr }}
        </v-flex>
        <v-flex v-else xs9>
          指定しない
        </v-flex>
      </v-layout>
    </template>
    <template>
      <v-subheader>間取り</v-subheader>
      <v-layout pl-4>
        <v-flex v-if="menuSetting.isValidFloorPlan" xs9>
          {{ floorPlansStr }}
        </v-flex>
        <v-flex v-else xs9>
          指定しない
        </v-flex>
      </v-layout>
    </template>
    <CampaignModalPageConfirmArea :menuSetting="menuSetting" />
    <template v-if="menuSetting.memo !== ''">
      <v-subheader>備考</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ menuSetting.memo }}
        </v-flex>
      </v-layout>
    </template>
  </Section>
</template>

<script>
import Section from './CampaignModalPageConfirmSection'
import CampaignModalPageConfirmArea from './CampaignModalPageConfirmArea'

export default {
  name: 'CampaignModalPageConfirmMansionTarget',
  components: {
    Section,
    CampaignModalPageConfirmArea,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
    priceTargetStr() {
      return (
        this.getPriceStr(this.menuSetting.priceTarget.minPrice) +
        ' ~ ' +
        this.getPriceStr(this.menuSetting.priceTarget.maxPrice)
      )
    },
    floorTargetStr() {
      return (
        this.menuSetting.floorTarget.floorThreshold +
        '階建て ' +
        this.getConditionStr(this.menuSetting.floorTarget.floorConditions)
      )
    },
    ageBuiltStr() {
      return (
        this.menuSetting.ageBuilt.ageBuiltThreshold +
        '年 ' +
        this.getConditionStr(this.menuSetting.ageBuilt.ageBuiltConditions)
      )
    },
    floorPlansStr() {
      return this.menuSetting.floorPlan.floorPlans.join(', ')
    },
  },
  methods: {
    getConditionStr(condition) {
      return condition === 'greater' ? '以上' : '以下'
    },
    getPriceStr(price) {
      switch (price) {
        case 0:
          return price + '円'
        case 100000:
          return '1億円'
        case null:
          return '指定なし'
        default:
          return price + '万円'
      }
    },
  },
}
</script>
